import { IIdentifyWebchatVisitorDTO } from 'modules/webchat/domain/dtos';
import { TWebchatVisitorType } from 'modules/webchat/domain/entities';
import { IWebchatVisitorsRepository } from 'modules/webchat/domain/repositories';
import { HTTPError, UseCaseError } from 'shared/domain/errors';

const TOO_MANY_REQUESTS = 429;

export default class IdentifyWebchatVisitorUseCase {
  constructor(private visitorsRepository: IWebchatVisitorsRepository) {}

  public async execute({
    phone,
  }: IIdentifyWebchatVisitorDTO): Promise<TWebchatVisitorType> {
    let type: TWebchatVisitorType | null;

    try {
      type = await this.visitorsRepository.identify({ phone });
    } catch (error) {
      if (error instanceof HTTPError && error.status === TOO_MANY_REQUESTS) {
        throw new UseCaseError(
          'Too many attempts. Wait a minute and try again',
        );
      }

      throw new UseCaseError(
        'We could not start the chat right now. Try again in a few moments',
      );
    }

    if (!type) {
      throw new UseCaseError(
        'We could not start the chat right now. Try again in a few moments',
      );
    }

    return type;
  }
}
